export const CATEGORIES = {
  Smartphones: "smartphones",
  Laptops: "laptops",
  Skincare: "skincare",
  Fragrances: "fragrances",
  Groceries: "groceries",
  All: "all",
};

export const API_URL = "https://dummyjson.com/products";
export const API_URL_COMMENTS = "https://dummyjson.com/comments/post";
export const RES_PER_PAGE = 4;
export const LENGTH_PASSWORD = 6;
export const API_KEY = "AIzaSyDjbq64VDX56Lwm38EBoD62NlihJ40Ry5E";
export const API_URL_STORE =
  "https://jet-shop-react-default-rtdb.firebaseio.com";

export const PRODUCTS_DEFAULT = "/products/all";
export const PRODUCT_ID = "/product/:productId";
export const PRODUCT = "/product";
export const PRODUCTS_CATEGORY = "/products/:category";
export const PRODUCTS = "/products/";
export const AUTH = "/auth";
export const SEARCH = "/products/search?q=";
export const CART = "/cart";
export const ACCOUNT = "/account";
export const HISTORY = "/history";
export const REMEMBER_PWD = "/remember-pwd";
export const KEY_SAVE_STORAGE_TOKEN = "token";
export const KEY_SAVE_CART_ITEMS = "cartItems";
export const MESSAGE_ALERT =
  "This action will immediately send the order, do you want to continue?";
